import { giphyDarkCharcoal, giphyRed } from '@giphy/js-brand'
import { SyntheticEvent } from 'react'
import styled from 'styled-components'
import { UploadFieldBlock } from './blocks'
import { UtilityButton } from './buttons'

const Input = styled(UploadFieldBlock)`
    display: flex;
    position: relative;
    height: 42px;
    width: 100%;

    input[type='text'] {
        width: 100%;
        height: 100%;
    }
`

const Button = styled(UtilityButton)`
    background: transparent;
    color: #fff;
`

const DeleteButton = styled(Button)`
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 36px;
    right: 4px;
    top: 1px;
    cursor: pointer;

    i {
        color: ${giphyDarkCharcoal};
    }

    i:hover {
        color: ${giphyRed};
    }
`

type Props = {
    className?: string
    value?: string
    placeholder: string
    onRemove?: () => void
    onInput?: (value: string) => void
    onFocus?: () => void
}

const CreationToolsCaptionInput = ({ className, value, onRemove, onInput, onFocus, placeholder }: Props) => {
    const onChange = (e: SyntheticEvent<HTMLInputElement, Event>) => {
        onInput && onInput(e.currentTarget.value)
    }

    return (
        <Input className={className}>
            <input
                {...{
                    type: 'text',
                    placeholder,
                    value,
                    onChange,
                    onFocus,
                }}
            />
            {onRemove && value && (
                <DeleteButton onClick={onRemove}>
                    <i className="ss-trash" />
                </DeleteButton>
            )}
        </Input>
    )
}

export default CreationToolsCaptionInput
